// extracted by mini-css-extract-plugin
module.exports = {"mobileNavigation":"MobileNavigation_mobileNavigation__5i_Hp","links":"MobileNavigation_links__cshVi","link":"MobileNavigation_link__YxR5w","close":"MobileNavigation_close__DaxKT"};